export default {
  title: 'Shipping',

  labels: {
    cost: 'Shipping cost'
  },

  notifications: {
    wrongValues: 'The entered information is not valid',

    edit: {
      success: 'Shipping information has been updated successfully',
      error: 'Update shipping information has error'
    }
  }
}
